import axios from 'axios';
import MockAdapter from "axios-mock-adapter"

const api = axios.create();

const mock = new MockAdapter(api, { delayResponse: 200 });

let users = [
    {
        "account_status": "disabled",
        "cognito_pool_id": "ap-south-1_h57sPitcY",
        "confirmation_status": 'yes',
        "user_id": '21230d4a-0011-70f7-23c6-60b542333116',
        "role": 'customer',
        "tpx_id": 'GTfqo7',
        "created": '2025-09-04 09:01:53.653385',
        "customer_id": "53PV",
        "email": "pavithra+user2@weberon.net",
        "name": "Pavithra HB",
        "phone": "+16458372768",
    },
    {
        "cognito_pool_id": "ap-south-1_h57sPitcY",
        "user_id": '61336d2a-2031-702e-756b-bc11b904921b',
        "role": 'customer',
        "tpx_id": '9zmogh',
        "created": '2025-09-04 07:58:02.089978',
        "customer_id": 'AX01',
        "email": "pavithra+passwordtest@weberon.net",
        "name": "Pavithra HB",
        "phone": "+16452398230",
    },
    {
        "account_status": "active",
        "cognito_pool_id": "ap-south-1_h57sPitcY",
        "role": 'customer',
        "tpx_id": '9zmogh',
        "created": '2025-09-04 07:58:02.089978',
        "customer_id": 'AX01',
        "email": "pavithra+test3@weberon.net",
        "name": "Pavithra HB",
        "phone": "+16457673573",
        "user_id": "01831d8a-3001-70b7-ddc5-57c536ff167e"
    },

    {
        "account_status": "disabled",
        "cognito_pool_id": "ap-south-1_h57sPitcY",
        "user_id": 'b173dd2a-50b1-7093-3751-ba8de1bdce6d',
        "role": 'customer',
        "tpx_id": '0v4a4e',
        "created": '2025-09-02 11:31:18.841858',
        "customer_id": 'USSZ',
        "email": "pavithra+cognitotest@weberon.net",
        "name": "Pavithra HB",
        "phone": "+16457673573",
    }

];

let plans = [
    {
        "plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190474",
        "created": "2025-06-15T12:41:16.285029",
        "updated": "2025-06-20T08:20:10.123456",
        "quota_id": "3498tg845",
        "monthly_price": 0,
        "annual_price": 0,
        "overage_price": 20,
        "name": "Free",
        "description": "This is a Free plan",
        "quota":
        {
            "campaigns": 3,
            "contacts": 50,
            "templates": 1,
            "collaterals": 50,
            "qrcodes": 20,
            "trackables": 50,
            "requests": 5
        },
    },
    {
        "plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d44",
        "created": "2025-06-19T12:41:16.285029",
        "updated": "2025-06-20T08:20:10.123456",
        "quota_id": "hdw8y85yubtuyb",
        "monthly_price": 39,
        "annual_price": 390,
        "overage_price": 10,
        "name": "Starter",
        "description": "This is a Starter plan",
        "quota":
        {
            "campaigns": 3,
            "contacts": 500,
            "templates": 1,
            "collaterals": 500,
            "qrcodes": 20,
            "trackables": 30,
            "requests": 5
        },
    },
    {
        "plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d45",
        "created": "2025-06-19T12:41:16.285029",
        "updated": "2025-06-20T09:30:45.654321",
        "quota_id": "8herjhgerjh484",
        "monthly_price": 70,
        "annual_price": 700,
        "overage_price": 8,
        "name": "Grow",
        "description": "This is Grow plan",
        "quota":
        {
            "campaigns": 2,
            "contacts": 1000,
            "templates": 5,
            "collaterals": 1000,
            "qrcodes": 20,
            "trackables": 30,
            "requests": 5
        },
    },
    {
        "plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d46",
        "created": "2025-06-19T12:41:16.285029",
        'updated': "2025-06-20T10:15:30.123456",
        "quota_id": "fkjgh487y58tg347",
        "monthly_price": 119,
        "annual_price": 1190,
        "overage_price": 5,
        "name": "Pro",
        "description": " This is Pro plan",
        "quota":
        {
            "campaigns": 5,
            "contacts": 2500,
            "templates": 15,
            "collaterals": 2500,
            "qrcodes": 20,
            "trackables": 30,
            "requests": 5
        },
    }
];

let activities = {
    "count": 6,
    "records": [
        {
            "created": "2025-06-10T13:41:02.731559",
            "customer_id": "PN8R",
            "uuid": "3f5091df-be05-4b9c-9586-e3daeabbd12c",
            "action": "Create PDF Generation Request",
            "additional_data": {
                "campaign_name": "test",
                "template_name": "Typed Default",
                "contacts": 11
            }
        },
        {
            "created": "2025-06-10T13:39:52.386346",
            "customer_id": "PN8R",
            "uuid": "2ab41ce2-8988-42f7-9373-fa474a5fdda0",
            "action": "Create PDF Generation Request",
            "additional_data": {
                "campaign_name": "test",
                "template_name": "E10 Letter Default",
                "contacts": 11,
            }
        },
        {
            "created": "2025-06-10T13:39:00.979245",
            "customer_id": "PN8R",
            "uuid": "037c829b-95a0-4f20-a204-c33a3bc7b4a0",
            "action": "Create Proof Template",
            "additional_data": {
                "template_name": "E10 Letter Default",
            }
        },
        {
            "created": "2025-06-10T13:37:57.460191",
            "customer_id": "PN8R",
            "uuid": "b2050f15-ae57-4958-83f9-02f18805e268",
            "action": "Create Proof Template",
            "additional_data": {
                "template_name": "Typed Default",
            }
        },
        {
            "created": "2025-06-10T13:36:38.731322",
            "customer_id": "PN8R",
            "uuid": "b9b1149b-9d00-497d-be8f-7dd085efd6e1",
            "action": "Upload Contacts",
            "additional_data": {
                "campaign_name": "test",
                "contacts": 1,
            }
        },
        {
            "created": "2025-06-10T13:22:09.844258",
            "customer_id": "PN8R",
            "uuid": "7e5baab8-76c0-4f34-87f4-344db8a2f65f",
            "action": "Create Campaign",
            "additional_data": {
                "campaign_name": "test",
            }
        }
    ],
    "last_evaluated_key": null
}

let adminActivities = {
    "count": 3,
    "records": [

        {
            "activity_log_id": "fn3847y743",
            "actor": "Admin",
            "resource_type": "Plan",
            "resource_id": "jhucvge76",
            "action": "Create",
            "details": {
                "id": "jhf87y4387tfgb8",
                "description": "Trial2 plan created",
            },
            "timestamp": "2025-10-25T10:20:30.123456"

        },

        {
            "activity_log_id": "efhy7g3u",
            "actor": "Admin",
            "resource_type": "Subscription",
            "resource_id": "jhucvge76",
            "action": "Activate",
            "details": {
                "id": "nueg8347634834",
                "description": "Trial1 subscription activated",
            },
            "timestamp": "2025-10-23T10:20:30.123456"

        },

        {
            "activity_log_id": "jgh85y587",
            "actor": "Admin",
            "resource_type": "Subscription",
            "resource_id": "jhucvge76",
            "action": "Suspend",
            "details": {
                "id": "bfr847tefhf",
                "description": "subscription suspended",
            },
            "timestamp": "2025-10-26T10:20:30.123456"

        },

    ]
}

let payments = [
    {
        "date": "2025-10-25T10:20:30.123456",
        "description": "Trial2 subscription plan activate",
        "amount": "$30"
    },
    {
        "date": "2025-10-15T10:20:30.123456",
        "description": "trial2 subscription plan Renew",
        "amount": "$30"
    },
    {
        "date": "2025-10-26T10:20:30.123456",
        "description": "Quota extensions",
        "amount": "$20"
    },
]

let profile = {
    "name": "Pavithra",
    "email": "pavithra@gmail.com",
    "phone": "+1234567890",
}

let subscriptions = [
    {
        "subscription_id": "vnfrejgh8g3ghriu",
        "customer_id": "RC90",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190474",
        "user": "pavithra@weberon.net",
        "name": "Pavithra H B",
        "plan": "Free",
        "billing_cycle": "Monthly",
        "status": "active",
        "start_date": "2025-11-01T10:20:30.123456",
        "end_date": "2026-01-25T10:20:30.123456",
        "payment_status": "NA",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "nueg8347634835",
        "customer_id": "HU79",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d44",
        "user": "pavithra@weberon.net",
        "name": "Pavithra",
        "plan": "Starter",
        "billing_cycle": "Monthly",
        "status": "active",
        "start_date": "2026-01-02T10:20:30.123456",
        "end_date": "2026-01-23T10:20:30.123456",
        "payment_status": "Paid",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "nueg8347634836",
        "customer_id": "HU78",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d45",
        "user": "pavithra@weberon.net",
        "name": "Pavithra",
        "plan": "Grow",
        "billing_cycle": "Annual",
        "status": "active",
        "start_date": "2025-11-01",
        "end_date": "2026-12-01",
        "payment_status": "Paid",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "nueg8347634834",
        "customer_id": "HU78",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d46",
        "user": "pavithra@weberon.net",
        "name": "Pavithra",
        "plan": "Pro",
        "billing_cycle": "Annual",
        "status": "active",
        "start_date": "2025-11-01T10:20:30.123456",
        "end_date": "2026-12-01T10:20:30.123456",
        "payment_status": "Paid",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "bfr847tefhf",
        "customer_id": "94LK",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d44",
        "user": "pavithra+test@weberon.net",
        "name": "Pavithra",
        "plan": "Starter",
        "billing_cycle": "Monthly",
        "status": "draft",
        "start_date": "2025-10-15",
        "end_date": "2026-11-15",
        "payment_status": "Paid",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "nre9834uejsnk",
        "customer_id": "8DG6",
        "name": "Pavithra",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190474",
        "user": "pavithra+test2@weberon.net",
        "plan": "Free",
        "billing_cycle": "Monthly",
        "status": "Awaiting Renewal",
        "start_date": "2025-10-01",
        "end_date": "2026-11-01",
        "payment_status": "Pending",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "fkngtuy548",
        "customer_id": "fh87",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d44",
        "user": "pavithra+test3@weberon.net",
        "name": "Pavithra",
        "plan": "Starter",
        "billing_cycle": "Annual",
        "status": "Suspended",
        "start_date": "2025-10-01",
        "end_date": "2026-11-01",
        "payment_status": "Pending",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "fhugy47giugf",
        "customer_id": "I9F4",
        "name": "Pavithra",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d49",
        "user": "pavithra+test5@weberon.net",
        "plan": "Grow",
        "billing_cycle": "Annual",
        "status": "Awaiting Renewal",
        "start_date": "2025-10-05",
        "end_date": "2026-11-05",
        "payment_status": "Pending",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "nrg8y45754",
        "customer_id": "8DG8",
        "name": "Pavithra",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190d45",
        "user": "pavithra+test4@weberon.net",
        "plan": "Grow",
        "billing_cycle": "Annual",
        "status": "Cancelled",
        "start_date": "2025-10-01",
        "end_date": "2026-11-01",
        "payment_status": "Pending",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
    },
    {
        "subscription_id": "jf47trfeye",
        "customer_id": "G36T",
        "name": "Pavithra",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190474",
        "user": "pavithra+test5@weberon.net",
        "plan": "Starter",
        "billing_cycle": "Monthly",
        "status": "Awaiting Renewal",
        "start_date": "2025-10-15",
        "end_date": "2026-11-15",
        "payment_status": "Pending",
        "created_timestamp": "2025-09-29T10:20:30.123456",
        "updated_timestamp": "2025-10-10T10:20:30.123456",
    },

]

let QuotaExtensions = [
    {
        "quota_extension_id": "mdfkj9484",
        "customer_id": "HF86",
        "subscription_id": "nueg8347634834",
        "quota": {
            "campaigns": 100,
            "contacts": 500,
            "templates": 10,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 50,
        },
        "used_quota": {
            "campaigns": 40,
            "contacts": 350,
            "templates": 6,
            "collaterals": 290,
            "qrcodes": 400,
            "trackables": 450,
            "requests": 30,
        },
        "status": "Active",
        "created_timestamp": "2025-11-20T10:20:30.123456",
        "price": 50
    },
    {
        "quota_extension_id": "dknf8ye8f3232",
        "customer_id": "Y7D9",
        "subscription_id": "bfr847tefhf",
        "quota": {
            "campaigns": 20,
            "contacts": 500,
            "templates": 10,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 5,
        },
        "used_quota": {
            "campaigns": 20,
            "contacts": 500,
            "templates": 10,
            "collaterals": 500,
            "qrcodes": 500,
            "trackables": 500,
            "requests": 5,
        },
        "status": "UsedUp",
        "created_timestamp": "2025-11-17T10:20:30.123456",
        "price": 100
    },
    {
        "quota_extension_id": "fniyr7tf734",
        "customer_id": "6v9D",
        "subscription_id": "nre9834uejsnk",
        "quota": {
            "campaigns": 20,
            "contacts": 500,
            "templates": 30,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 35,
        },
        "used_quota": {
            "campaigns": 16,
            "contacts": 350,
            "templates": 23,
            "collaterals": 250,
            "qrcodes": 290,
            "trackables": 280,
            "requests": 24,
        },
        "status": "Active",
        "created_timestamp": "2025-11-17T10:20:30.123456",
        "price": 150
    }

]

let usageMetrics = [
    {
        "usage_metric_id": "vnfrejgh8g3ghriu",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2026-01-17",
        "end_date": "2026-02-17",
        "created_timestamp": "2026-01-17T10:20:30.123456",
        "quota": {
            "campaigns": 200,
            "contacts": 500,
            "templates": 100,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 50,
        },
        "used_quota": {
            "campaigns": "110",
            "contacts": "300",
            "templates": "65",
            "collaterals": "10",
            "requests": "34",
            "trackables": "280",
            "qrcodes": "400",
        }
    },
    {
        "usage_metric_id": "nueg8347634835",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2026-01-01",
        "end_date": "2026-02-01",
        "created_timestamp": "2026-01-01T10:20:30.123456",
        "quota": {
            "campaigns": 200,
            "contacts": 500,
            "templates": 100,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 50,
        },
        "used_quota": {
            "campaigns": "110",
            "contacts": "300",
            "templates": "65",
            "collaterals": "29",
            "requests": "34",
            "trackables": "280",
            "qrcodes": "400",
        }
    },
    {
        "usage_metric_id": "nueg8347634835",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2026-12-01",
        "end_date": "2026-01-01",
        "created_timestamp": "2026-12-01T10:20:30.123456",
        "quota": {
            "campaigns": 200,
            "contacts": 500,
            "templates": 100,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 50,
        },
        "used_quota": {
            "campaigns": "110",
            "contacts": "300",
            "templates": "65",
            "collaterals": "234",
            "requests": "34",
            "trackables": "280",
            "qrcodes": "400",
        }
    },

    {
        "usage_metric_id": "nueg8347634836",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2026-11-01",
        "end_date": "2026-12-01",
        "created_timestamp": "2026-11-01T10:20:30.123456",
        "quota": {
            "campaigns": 200,
            "contacts": 500,
            "templates": 100,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 50,
        },
        "used_quota": {
            "campaigns": "110",
            "contacts": "300",
            "templates": "65",
            "collaterals": "368",
            "requests": "34",
            "trackables": "280",
            "qrcodes": "400",
        }
    },
    {
        "usage_metric_id": "jhd8347tr3487",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2026-01-17",
        "end_date": "2026-02-17",
        "created_timestamp": "2026-01-17T10:20:30.123456",
        "quota": {
            "campaigns": 200,
            "contacts": 500,
            "templates": 100,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 50,
        },
        "used_quota": {
            "campaigns": "110",
            "contacts": "300",
            "templates": "65",
            "collaterals": "350",
            "requests": "34",
            "trackables": "280",
            "qrcodes": "400",
        }
    },
    {
        "usage_metric_id": "jhd8347tr3487",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2025-12-17",
        "end_date": "2026-01-17",
        "created_timestamp": "2025-11-17T10:20:30.123456",
        "quota": {
            "campaigns": 20,
            "contacts": 500,
            "templates": 10,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 5,
        },
        "used_quota": {
            "campaigns": "2",
            "contacts": "50",
            "templates": "1",
            "collaterals": "30",
            "requests": "1",
            "trackables": "5",
            "qrcodes": "5",
        }

    },
    {
        "usage_metric_id": "jhd8347tr3487",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2025-11-17",
        "end_date": "2025-12-17",
        "created_timestamp": "2025-11-17T10:20:30.123456",
        "quota": {
            "campaigns": 20,
            "contacts": 500,
            "templates": 10,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 5,
        },
        "used_quota": {
            "campaigns": "2",
            "contacts": "50",
            "templates": "1",
            "collaterals": "30",
            "requests": "1",
            "trackables": "5",
            "qrcodes": "5",
        }

    },
    {
        "usage_metric_id": "jhd8347tr3487",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2025-10-17",
        "end_date": "2025-11-17",
        "created_timestamp": "2025-11-17T10:20:30.123456",
        "quota": {
            "campaigns": 20,
            "contacts": 500,
            "templates": 10,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 5,
        },
        "used_quota": {
            "campaigns": "2",
            "contacts": "50",
            "templates": "1",
            "collaterals": "30",
            "requests": "1",
            "trackables": "5",
            "qrcodes": "5",
        }

    },
    {
        "usage_metric_id": "jhd8347tr3487",
        "customer_id": "87YG",
        "subscription_id": "nueg8347634834",
        "start_date": "2025-09-17",
        "end_date": "2025-10-17",
        "created_timestamp": "2025-11-17T10:20:30.123456",
        "quota": {
            "campaigns": 20,
            "contacts": 500,
            "templates": 10,
            "collaterals": 500,
            "trackables": 500,
            "qrcodes": 500,
            "requests": 5,
        },
        "used_quota": {
            "campaigns": "2",
            "contacts": "50",
            "templates": "1",
            "collaterals": "30",
            "requests": "1",
            "trackables": "5",
            "qrcodes": "5",
        }

    }
]

let subscription = [
    {
        "subscription_id": "vnfrejgh8g3ghriu",
        "customer_id": "RC90",
        "subscription_plan_id": "a3c7d2fc-c2ec-479b-9b3d-991f12190474",
        "user": "pavithra@weberon.net",
        "name": "Pavithra H B",
        "plan": "Free",
        "billing_cycle": "Monthly",
        "status": "active",
        "start_date": "2025-11-01",
        "end_date": "2026-12-01",
        "payment_status": "NA",
        "created_timestamp": "2025-10-25T10:20:30.123456",
        "updated_timestamp": "2025-10-30T10:20:30.123456",
        "price": "$0",
        "features": {
            "collaterals": 50,
            "overage": 20
        }
    },
]

mock.onGet('/users').reply(200, users);

mock.onGet('/subscriptions').reply(200, subscriptions);

mock.onGet('/subscription').reply(200, subscription)

// Helper to format date as UTC ISO string
const formatDate = (date) => {
    return date.toISOString();
};

mock.onPost('/subscriptions').reply((config) => {
    console.log("Request received", config);

    const newSubscription = JSON.parse(config.data);
    console.log("New Subscription Data", newSubscription);

    const today = new Date();

    if (newSubscription.status === 'active') {
        newSubscription.start_date = formatDate(today);

        const endDate = new Date(today);
        if (newSubscription.billing_cycle === "Monthly") {
            endDate.setDate(endDate.getDate() + 30);
        } else if (newSubscription.billing_cycle === "Annual") {
            endDate.setDate(endDate.getDate() + 360);
        }
        newSubscription.end_date = formatDate(endDate);
    }
    newSubscription.created_timestamp = today.toISOString();


    console.log("Subscription with dates", newSubscription);

    subscriptions.push(newSubscription);
    console.log("Subscriptions after creating", subscriptions);

    return [201, newSubscription];
});

mock.onPost(/\/subscriptions\/([^/]+)\/actions$/).reply((config) => {
    console.log("subscription action request received", config);
    console.log("subscription action request received", config.data);

    try {
        // Extract subscription_id from URL
        const match = config.url.match(/\/subscriptions\/([^/]+)\/actions$/);
        const subscriptionId = match ? match[1] : null;

        if (!subscriptionId) {
            return [400, { message: "Invalid subscription ID" }];
        }

        // Parse request payload
        const parsedData = JSON.parse(config.data);
        const action = parsedData.action;
        console.log("Payload received for activation:", parsedData.action);

        // Find the existing subscription
        const subscriptionIndex = subscriptions.findIndex(
            (sub) => sub.subscription_id === subscriptionId
        );

        if (subscriptionIndex === -1) {
            return [404, { message: "Subscription not found" }];
        }
        if (action === 'activate') {

            const subscription = subscriptions[subscriptionIndex];

            const today = new Date();

            const endDate = new Date(today);
            if (parsedData.billing_cycle === "Monthly") {
                endDate.setDate(endDate.getDate() + 30);
            } else if (parsedData.billing_cycle === "Annual") {
                endDate.setDate(endDate.getDate() + 360);
            }

            const updatedSubscription = {
                ...subscription,
                user: parsedData.user || subscription.user,
                plan: parsedData.plan || subscription.plan,
                billing_cycle: parsedData.billing_cycle || subscription.billing_cycle,
                payment_status: parsedData.payment_status || subscription.payment_status,
                status: "active",
                start_date: formatDate(today),
                updated_timestamp: new Date().toISOString(),
                end_date: formatDate(endDate)
            };

            // Save updated subscription
            subscriptions[subscriptionIndex] = updatedSubscription;

            console.log("Updated subscription:", updatedSubscription);

            return [201, updatedSubscription];
        }
        else if (action === 'extend_quota') {
            QuotaExtensions.push(parsedData);
            console.log("Quota extensions after creating", QuotaExtensions)
            return [201, parsedData];
        }
        else if (action === 'suspend') {
            const subscription = subscriptions[subscriptionIndex];

            // Update subscription details
            const updatedSubscription = {
                ...subscription,
                status: "Suspended",
                updated_timestamp: new Date().toISOString(),
            };

            // Save updated subscription
            subscriptions[subscriptionIndex] = updatedSubscription;

            console.log("Updated subscription:", updatedSubscription);

            return [201, updatedSubscription];
        }
        else if (action === 'cancel') {
            const subscription = subscriptions[subscriptionIndex];

            // Update subscription details
            const updatedSubscription = {
                ...subscription,
                status: "Cancelled",
                updated_timestamp: new Date().toISOString(),
            };

            subscriptions[subscriptionIndex] = updatedSubscription;

            console.log("Updated subscription:", updatedSubscription);

            return [201, updatedSubscription];
        } else if (action === 'renew') {
            console.log("Renewing subscription")
            const subscription = subscriptions[subscriptionIndex];

            const newPlan = parsedData.plan_change ? parsedData.plan : subscription.plan;

            const newBillingCycle = parsedData.update_billing_cycle ? parsedData.billing_cycle : subscription.billing_cycle;
            const updatedSubscription = {
                ...subscription,
                status: "active",
                plan: newPlan,
                billing_cycle: newBillingCycle,
                payment_status: parsedData.payment_status,
                updated_timestamp: new Date().toISOString(),
            };

            subscriptions[subscriptionIndex] = updatedSubscription;

            console.log("Updated subscription:", updatedSubscription);

            return [201, updatedSubscription];
        } else if (action === 'upgrade') {
            console.log("Upgrade subscription")
            const subscription = subscriptions[subscriptionIndex];

            const newPlan = parsedData.upgrade ? parsedData.plan : subscription.plan;

            const newBillingCycle = parsedData.update_billing_cycle ? parsedData.billing_cycle : subscription.billing_cycle;
            const startDate = new Date();

            const endDate = new Date(startDate);
            endDate.setDate(
                endDate.getDate() + (newBillingCycle === "Monthly" ? 30 : 360)
            );

            console.log("Start date:", startDate.toISOString());
            console.log("End date:", endDate.toISOString());

            const updatedSubscription = {
                ...subscription,
                plan: newPlan,
                billing_cycle: newBillingCycle,
                payment_status: parsedData.payment_status,
                updated_timestamp: new Date().toISOString(),
                start_date: formatDate(startDate),
                end_date: formatDate(endDate),
            };

            subscriptions[subscriptionIndex] = updatedSubscription;

            console.log("Updated subscription:", updatedSubscription);

            return [201, updatedSubscription];
        }
    } catch (error) {
        console.error("Error in activation mock:", error);
        return [500, { message: "Internal Server Error" }];
    }
});

mock.onGet('/profile').reply(200, profile);

mock.onGet('/subscription-plans').reply(200, plans);

mock.onPost("/subscription-plans").reply((config) => {
    console.log("Request received", config)
    const newPlan = JSON.parse(config.data);
    plans.push(newPlan);
    console.log("Plans after creating", plans)
    return [201, newPlan];
});


mock.onPatch(/\/subscription-plans\/[^/]+/).reply((config) => {
    console.log("Patch Request received", config)

    const plan_id = config.url.split('/').pop();
    const updatedPlanData = JSON.parse(config.data);

    const planIndex = plans.findIndex((plan) => plan.plan_id === plan_id);
    if (planIndex === -1) {
        return [404, { message: "Plan not found" }];
    }
    plans[planIndex] = {
        ...plans[planIndex],
        ...updatedPlanData,
        updated: new Date().toISOString(),
    };
    console.log("Plans after updating", plans[planIndex])
    return [200, plans[planIndex]]

});

mock.onGet('/activities').reply(200, activities);

mock.onGet('activity-logs').reply(200, adminActivities)

mock.onGet('usage-metrics').reply(200, usageMetrics);

mock.onGet('payments').reply(200, payments)

mock.onGet('/quota-extension').reply(200, QuotaExtensions);

mock.onGet(/\/subscriptions\/([^/]+)\/quota-extensions/).reply((config) => {
    try {
        const match = config.url && config.url.match(/\/subscriptions\/([^/]+)\/quota-extensions/);
        const subscriptionId = match ? match[1] : null;
        if (!subscriptionId) {
            return [400, { message: "Invalid subscription ID" }];
        }

        // return matching extensions (empty array if none)
        const result = QuotaExtensions.filter((q) => q.subscription_id === subscriptionId);
        return [200, result];
    } catch (error) {
        console.error("Error in quota-extensions mock:", error);
        return [500, { message: "Internal Server Error" }];
    }
});

export default api;
